// extracted by mini-css-extract-plugin
export default {"ul":"FormLanguages_ul__ojVVG"};